export default "__VITE_ASSET__BpmjLose__"